@if (tooltipTitle || tooltipDescription) {
  <div class="tooltip-popover-header">
    @if (tooltipTitle) {
      <div class="tooltip-popover-title">{{ tooltipTitle }}</div>
    }
    @if (tooltipDescription) {
      <cs-note class="tooltip-popover-description">{{ tooltipDescription }}</cs-note>
    }
  </div>
}
<div class="tooltip-popover-content">
  @if (tooltipContent) {
    <div class="tooltip-popover-text">{{ tooltipContent }}</div>
  }
  @if (tooltipTemplate) {
    <div class="tooltip-popover-html">
      <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
    </div>
  }
</div>
@if (buttonText) {
  <cs-button class="tooltip-popover-button" secondary full (click)="onButtonClick()">
    {{ buttonText }}
  </cs-button>
}